import "./App.scss";
import { BrowserRouter, Routes, Route, useRouteError } from "react-router-dom";
import { ErrorPage } from "./core/core";
import { addLocale, locale, PrimeReactProvider } from "primereact/api";
import { locales } from "./utils/helpers";

import Dashboard from "./Components/dashboard";
import AvfDashboard from "./Components/avf-dashboard";

function App() {
  addLocale("en-au", locales["en-au"]);
  addLocale("en-gb", locales["en-gb"]);
  addLocale("en", locales["en"]);
  const userLocale = navigator.language || "";
  const localeAvailable = locales.hasOwnProperty(userLocale);
  if (!userLocale || !localeAvailable) {
    locale("en-au");
  } else {
    locale(userLocale.toLowerCase());
  }

  const errorMessage = "Access denied.";
  const validReferrer = document.referrer.indexOf("visualvault.com") > -1;

  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <Routes>
          {/* <Route path="avf-dashboard" element={<AvfDashboard />}></Route> */}
          <Route
            path="avf-dashboard"
            element={validReferrer ? <AvfDashboard /> : <ErrorPage message={errorMessage} />}
          ></Route>

          <Route path="" element={<Dashboard />}></Route>
          {/* <Route path="" element={validReferrer ? <Dashboard /> : <ErrorPage message={errorMessage} />}></Route> */}

          {/**
           * Default route
           */}
          <Route path="*" element={<ErrorPage message={errorMessage} />} errorElement={<ErrorBoundary />} />
        </Routes>
      </BrowserRouter>
    </PrimeReactProvider>
  );

  function ErrorBoundary() {
    let error: any = useRouteError();
    console.error(error);
    // Uncaught ReferenceError: path is not defined
    return <ErrorPage message={`${error ?? errorMessage}`} />;
  }
}

export default App;
